import { axiosWithAuth } from "../../helpers";

export const reassignMerchantsService = {
	getNewAgents,
	reassignTo,
	reassignAllFromTo,
};

const API_URL = process.env.REACT_APP_API_URL;

function getNewAgents(oldAgentId) {
	const options = {
		url: `${API_URL}/api/reassign/new-agents`,
		params: {
			oldAgentId,
		},
	};

	return axiosWithAuth(options);
}

function reassignTo({ newAgentId, merchantIds }) {
	const options = {
		url: `${API_URL}/api/reassign/to/${newAgentId}`,
		method: "POST",
		data: { merchantIds },
	};

	return axiosWithAuth(options);
}

function reassignAllFromTo({ oldAgentId, newAgentId }) {
	const options = {
		url: `${API_URL}/api/reassign/all/from/${oldAgentId}/to/${newAgentId}`,
		method: "POST",
	};

	return axiosWithAuth(options);
}
